<!-- TODO para controlar que no se muestre el "no existe ningun...." se puede crear una variable "load = true" y en el momento de cargar el array pasarla a false
      v-if="idOperadorSeleccionado !== null && !load"-->
<template>
  <div v-if="idOperadorSeleccionado !== null">
    <vx-card>
      <vs-navbar type="gradient" v-model="idOperadorSeleccionado" class="textoOperadoresDocumentos">

        <div slot="title">
          <vs-navbar-title>
            Operadores
          </vs-navbar-title>
        </div>

        <vs-navbar-item v-for="(operador, index) in operadores" :key="index" :index="operador.id">
          <a href="#">{{operador.operador}}</a>
        </vs-navbar-item>
      </vs-navbar>

      <vs-collapse accordion type="margin" >
        <vs-collapse-item v-for="(categoria, index) in categorias" :key="index" >
          <div slot="header" class="textoCategoriaDocumentos">
            {{categoria}}
          </div>
          <vx-card v-for="(manual, index) in manualesFiltradosPorOperador" :key="index" class="mb-2">
            <vs-row v-if="categoria === manual.valTipoDocumento.nombre">
              <vs-col vs-type="flex" vs-align="center" vs-w="6">
                <span class="text-lg textoOperacionComentarioDateTime" @click="descargaDocumento(manual.id, manual.fichero)"> {{ manual.fichero }} </span>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-w="5">
                <p @click="descargaDocumento(manual.id, manual.fichero)">{{manual.descripcion}}</p>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
                <feather-icon class="mr-4 hover:text-primary cursor-pointer" @click="descargaDocumento(manual.id, manual.fichero)" icon="DownloadIcon"/>
              </vs-col>
            </vs-row>
          </vx-card>
        </vs-collapse-item>
      </vs-collapse>

    </vx-card>
  </div>
  <div v-else>
    <vx-card>
      <vs-alert color="danger" icon-pack="feather" icon="icon-info">
        <span>No existe ningún documento que mostrar.</span>
      </vs-alert>
    </vx-card>
  </div>
</template>

<script>
import valTiposDocumentosStore from '@/store/configuracion/val-tipos-documentos/index.js'
import manualesStore from '@/store/configuracion/manuales/index.js'
import VueLink from 'vue-link'
import VxCard from '../../../components/vx-card/VxCard.vue'

export default {
  name: 'ManualDashboard',
  components: {
    VueLink,
    VxCard
  },
  data () {
    return {
      categorias: [],
      manuales: [],
      operadores: [],
      idOperadorSeleccionado: null
    }
  },
  computed: {
    manualesFiltradosPorOperador () {
      const operadorSeleccionado = this.operadores.find(({ id }) => id === this.idOperadorSeleccionado)
      const man = this.manuales.filter((element) => { return element.operador === operadorSeleccionado.operador })
      this.actualizarCategorias(man, operadorSeleccionado.operador)
      return man      
    }
  },
  methods: {
    async descargaDocumento (id, nombre) {
      await this.$store.dispatch('manualesStore/downloadDocumento', id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', nombre)
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.log('ERROR', error)
        })
    }, 
    actualizarCategorias (manuales, operador) {
      const c = new Map() // Categoría
      const datos = []
      for (const item of manuales) {
        // Para crear as categorías do operador seleccionado inicialmente comprobamos que a categoría non exista no array de categorías (c) e que 
        // o operador do elemento que estamos evaluando sexa o mesmo que o primeiro operador introducido no array de operadores (this.operadores[0])
        if (!c.has(item.operador) && item.operador === operador) {
          c.set(item.valTipoDocumento.nombre, true)
          datos.push(item.valTipoDocumento.nombre)
        }
      }
      const filtered = datos.filter((item, index) => {
        return datos.indexOf(item) === index
      })
      this.categorias = filtered
    }
  }, 
  async created () {
    if (!valTiposDocumentosStore.isRegistered) {
      this.$store.registerModule('valTiposDocumentosStore', valTiposDocumentosStore)
      valTiposDocumentosStore.isRegistered = true
    }
    if (!manualesStore.isRegistered) {
      this.$store.registerModule('manualesStore', manualesStore)
      manualesStore.isRegistered = true
    }

    await this.$store.dispatch('manualesStore/getDocumentos')
    this.manuales = JSON.parse(JSON.stringify(this.$store.state.manualesStore.manuales))

    // await this.$store.dispatch('valTiposDocumentosStore/getTiposDocumentos')
    // this.categorias = this.$store.state.valTiposDocumentosStore.tiposDocumentos.filter((doc) => doc.categoria === 'MANUAL')
    const o = new Map() // Operador
    const c = new Map() // Categoría
    for (const item of this.manuales) {
      if (!o.has(item.operador)) {
        o.set(item.operador, true)
        this.operadores.push({
          id: item.id,
          operador: item.operador
        })
      }
    }
    if (this.operadores.length !== 0) {  // Se non hai operadores é que non hai manuais subidos aínda
      this.actualizarCategorias(JSON.parse(JSON.stringify(this.manuales)), this.operadores[0].operador)
      this.idOperadorSeleccionado = this.operadores[0].id
    } else {
      this.idOperadorSeleccionado = null
    }
  }
}
</script>